<template>
	<div class="border-connectProBlue border-2 pl-8 pr-8 pb-8 pt-4 rounded min-h-72">
		<div v-if="process.customer.customer_main !== null">
			<div class="flex space-x-16 border-b-2 pb-5">
				<div class="text-lg text-black font-bold">
					{{ $t('sign_pending_documents') }}
				</div>
			</div>
			<div v-if="signPendingDocuments.length !== 0" class="grid grid-cols-3 gap-x-8 xl:gap-x-24 gap-y-4 mt-4 pb-5 mb-5" style="text-align: start">
				<div v-for="document in signPendingDocuments" :key="document.id" class="font-medium">
					{{ document.document_type === 'misc' ? document.misc_name : document.label }}
				</div>
			</div>
			<div class="justify-start flex mt-4 mb-5" v-else>{{ $t('none_available') }}</div>

			<div class="mt-6 justify-end flex">
				<BaseButton class="btn-blue" @click="signDocument">{{ $t('new_sign_request') }}</BaseButton>
			</div>
		</div>
		<div class="flex space-x-16" v-else>
			<div class="text-black font-bold">
				{{ $t('customer_app_not_installed') }}
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { PdfApiFactory } from '@/api/generated';
import defaultConfiguration from '@/api/defaultConfiguration';

export default {
	name: 'ProcessDocumentsSignTab',
	components: { BaseButton },
	data() {
		return {
			signPendingDocuments: [],
			signedDocuments: [],
		};
	},
	props: {
		process: null,
	},
	methods: {
		signDocument() {
			this.$router.push({
				name: 'management.process.sign_documents',
				params: { customerId: this.$route.params.customer, processId: this.$route.params.processId },
			});
		},
		getDocuments() {
			PdfApiFactory(defaultConfiguration.config(), defaultConfiguration.basePath, defaultConfiguration.axios)
				.pdfDamagecasesIdAllSignableDocumentGet(this.$route.params.processId)
				.then(response => {
					this.signPendingDocuments = response.data.data;
				});
		},
	},
	watch: {
		'$store.getters.getUploadedNew': function() {
			if (this.$store.getters.getUploadedNew) {
				this.getDocuments();
			}
		},
	},
	created() {
		this.getDocuments();
	},
};
</script>

<style scoped></style>
